import { FC } from 'react'

import { Toggle, ToggleSizes } from '@inno-ui/toggle'
import { useTranslation } from 'react-i18next'

import styles from './ShareArtifactPanel.module.scss'
import { ShareArtifactPanelProps } from './ShareArtifactPanel.types'
import { SharePickers } from './components/SharePickers'
import { SharedList } from './components/SharedList'
import { StatusBanner } from './components/StatusBanner'
import { useShareArtifactPanel } from './useShareArtifactPanel'

export const ShareArtifactPanel: FC<ShareArtifactPanelProps> = ({
  artifact
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'widgets.aiAgent' })
  const panel = useShareArtifactPanel(artifact)

  return (
    <div className={styles.panel}>
      <StatusBanner
        artifact={artifact}
        status={panel.status}
        isShared={panel.isShared}
        busy={panel.busy}
        onResubmit={panel.resubmit}
      />

      {panel.myOrgId && (
        <div className={styles.orgRow}>
          <Toggle
            checked={panel.isOrgShared}
            onChange={panel.toggleOrg}
            title={t('everyoneInOrg')}
            label={panel.orgLabel}
            size={ToggleSizes.S}
            disabled={panel.busy}
          />
        </div>
      )}

      <SharePickers
        busy={panel.busy}
        positionItems={panel.positionItems}
        positionValue={panel.positionValue}
        onPositionsChange={panel.handlePositionsChange}
        peopleItems={panel.dropdownItems}
        selectedUser={panel.selectedUser}
        isSearchingPeople={panel.isSearching}
        onPeopleSelect={panel.handleSelect}
        onPeopleSearch={panel.onPeopleSearch}
        onPeopleClear={panel.onPeopleClear}
        onPeopleClose={panel.onPeopleClose}
      />

      <SharedList
        busy={panel.busy}
        isOrgShared={panel.isOrgShared}
        positionShares={panel.positionShares}
        userShares={panel.userShares}
        onRemovePosition={panel.removePosition}
        onRemoveUser={panel.remove}
      />
    </div>
  )
}
